import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BrandVarEntity, BrandVariableTextProperties } from 'app/account/brand-variable';
import { WidgetFontDescription } from 'app/campaign/widgets.model';
import { AccountCustomFont } from '../../../account-settings-models';
import WidgetComponentHelpers from 'app/campaign/widget-component-helpers';

@Component({
  selector: 'app-font-menu',
  templateUrl: './font-menu.component.html',
  styleUrl: './font-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FontMenuComponent {
  @Output() openFontFamilyFlyout = new EventEmitter();
  @Output() emitUpdatesFontOnBrandVariables = new EventEmitter();
  @Input() customFonts: AccountCustomFont[];
  @Input() brandVariablesErrorsVar: any;
  @Input() typeVariable: string;
  @Input() defaultFonts: Array<WidgetFontDescription>;
  @Input() set setTextProperties(textProperties) {
    if (textProperties) {
      this.textProperties = textProperties;
      this.setInitialUnit();
    }
  }
  public textProperties: BrandVariableTextProperties;
  public AVAILABLE_FONT_WEIGHTS = [100, 200, 300, 400, 500, 600, 700, 800, 900];
  public AVAILABLE_UNITS = ['px', 'em', 'rem'];
  public BrandVarEntity = BrandVarEntity;
  public units = { letterSpacing: 'em', lineHeight: 'em', fontSize: 'px' };

  constructor(private translateService: TranslateService) {}

  public validateFont(prop: BrandVarEntity, value?): void {
    if (value) this.textProperties[prop] = value.target.value;
    this.brandVariablesErrorsVar[prop] = '';
    if (this.textProperties[prop] === null || this.textProperties[prop] < 0) {
      this.brandVariablesErrorsVar[prop] = this.translateService.instant('generic.validation.error-wrong-number');
    }
    if ([BrandVarEntity.FontSize, BrandVarEntity.LineHeight, BrandVarEntity.LetterSpacing].includes(prop)) {
      this.replaceUnit(prop);
    }
    this.emitUpdatesFontOnBrandVariables.emit({ typeVariable: this.typeVariable, typeProperty: prop });
  }

  public replaceUnit(prop: BrandVarEntity): void {
    if (!/(px|em|rem)/.test(this.textProperties[prop])) {
      this.textProperties[prop] = this.textProperties[prop] + this.units[prop];
    } else {
      this.textProperties[prop] = this.textProperties[prop].replace(/(px|em|rem)/g, (match) => {
        return this.units[prop];
      });
    }
  }

  public setInitialUnit(): void {
    for (const key in this.textProperties) {
      if (
        key === BrandVarEntity.LineHeight ||
        key === BrandVarEntity.LetterSpacing ||
        key === BrandVarEntity.FontSize
      ) {
        const matchUnit = this.textProperties[key].match(/(px|em|rem)/);
        if (matchUnit) {
          this.units[key] = matchUnit[0];
        }
      }
    }
  }

  public onArrowKey(prop: BrandVarEntity, event: KeyboardEvent): void {
    let step: number;
    if (this.units[prop] === 'px') step = 1;
    if (this.units[prop] === 'em' || this.units[prop] === 'rem') step = 0.1;
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      if (event.key === 'ArrowUp') {
        this.textProperties[prop] =
          Math.round(
            (WidgetComponentHelpers.extractNumberFromUnitString(this.textProperties[prop], this.units[prop]) + step) *
              10,
          ) / 10;
      } else if (event.key === 'ArrowDown') {
        this.textProperties[prop] =
          Math.round(
            (WidgetComponentHelpers.extractNumberFromUnitString(this.textProperties[prop], this.units[prop]) - step) *
              10,
          ) / 10;
      }
      this.validateFont(prop, { target: { value: this.textProperties[prop] } });
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
